
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import routerProvider from '@/router'
import { Route } from 'vue-router'
import searcherry from '@/services/Searcherry/Searcherry'
import { SuggestData } from '@/data-models/SuggestData'
import { CorrectEventData } from '@/services/Statistic/PostData'
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'
import searchApiClient from '@/services/SearchApiClient/SearchApiClient'

@Component
export default class SearchRow extends Vue {
  @Prop() searchPhraseProp!: string
  searchPhrase: string = this.searchPhraseProp
  searchPhraseLatencyTimer: number | null = null
  widgetStyle = searcherryConfig.widgetStyle

  @Watch('searchPhraseProp')
  onSearchPhrasePropChanged (val: string) {
    if (this.searchPhrase.trim() !== val) {
      this.searchPhrase = val
    }
  }

  @Prop() searchSuggestsProp!: Array<any>
  searchSuggests: Array<SuggestData> = []

  @Watch('searchSuggestsProp')
  onSearchSuggestsPropChanged () {
    this.searchSuggests = []
    for (let i in this.searchSuggestsProp) {
      if (!this.searchSuggestsProp.hasOwnProperty(i)) {
        continue
      }
      let suggest = this.searchSuggestsProp[i]
      if (suggest.options.length > 0) {
        for (let j in suggest.options) {
          if (!suggest.options.hasOwnProperty(j)) {
            continue
          }
          let option = suggest.options[j]
          let suggestModel = new SuggestData()
          suggestModel.initialWord = suggest.word
          suggestModel.value = option
          this.searchSuggests.push(suggestModel)
        }
      }
    }
  }

  @Prop() searchCorrectsProp!: Array<any>
  searchCorrects: Array<SuggestData> = []

  @Watch('searchCorrectsProp')
  onSearchCorrectsPropChanged () {
    this.searchCorrects = []
    for (let i in this.searchCorrectsProp) {
      if (!this.searchCorrectsProp.hasOwnProperty(i)) {
        continue
      }
      let suggest = this.searchCorrectsProp[i]
      let suggestModel = new SuggestData()
      suggestModel.initialWord = suggest.initialWord
      suggestModel.value = suggest.correctWord
      this.searchCorrects.push(suggestModel)
    }
  }

  mounted () {
    let el = document.getElementById('srchrry-search')

    let timer = setInterval(() => {
      if (el !== null) {
        if (window.getComputedStyle(el).visibility !== 'hidden') {
          el.focus()
          clearInterval(timer)
        }
      } else {
        clearInterval(timer)
      }
    }, 100)
  }

  @Watch('$route')
  onRouteChanged (to: Route, from: Route) {
    if (to.params.searchPhrase && this.searchPhrase !== to.params.searchPhrase) {
      if (this.searchPhrase.trim() !== to.params.searchPhrase) {
        this.searchPhrase = to.params.searchPhrase
      }
    }
  }

  @Watch('searchPhrase')
  onSearchPhraseChanged (to: string, from: string): void {
    to = to.trim()
    from = from.trim()
    if (to === from) {
      return
    }

    let router = routerProvider.getRouter()
    if (router.currentRoute.params['searchPhrase'] && router.currentRoute.params['searchPhrase'] === to) {
      return
      // совпадает с текущим роутом, ничего не делаем
    }

    searchApiClient.abortRequest()

    if (this.searchPhraseLatencyTimer !== null) {
      clearTimeout(this.searchPhraseLatencyTimer)
    }

    this.searchPhraseLatencyTimer = setTimeout(() => {
      if (to.length > 0) {
        router.push({ name: 'results', params: { searchPhrase: to } })
      } else {
        if (router.currentRoute.name !== 'main') {
          router.push({ name: 'main' })
        }
      }
    }, 300)
  }

  suggestClick (suggest: SuggestData): void {
    this.searchPhrase = this.searchPhrase.toLowerCase().replace(suggest.initialWord, suggest.value)
    searcherry.generateEvent('correctClick')
    searcherry.saveSearchPhrase(this.searchPhrase)

    let correctEvent = new CorrectEventData()
    correctEvent.initialWord = suggest.initialWord
    correctEvent.correctWord = suggest.value
    searcherry.statisticService.correctEvent(correctEvent)
  }

  correctClick (suggest: SuggestData): void {
    this.searchPhrase = this.searchPhrase.toLowerCase().replace(suggest.initialWord, suggest.value)
    searcherry.generateEvent('correctClick')
    searcherry.saveSearchPhrase(this.searchPhrase)

    let correctEvent = new CorrectEventData()
    correctEvent.initialWord = suggest.initialWord
    correctEvent.correctWord = suggest.value
    searcherry.statisticService.correctEvent(correctEvent)
  }

  searchRowFocusOut (): void {
    searcherry.saveSearchPhrase(this.searchPhrase)
  }
}
